// extracted by mini-css-extract-plugin
export var animationContainer = "_pr-0";
export var footer = "_pr-1";
export var gray = "_pr-2";
export var lineItem = "_pr-3";
export var lineItemImage = "_pr-4";
export var lineItemInfo = "_pr-5";
export var lineItemText = "_pr-6";
export var lineItems = "_pr-7";
export var modalContent = "_pr-8";
export var options = "_pr-9";
export var orderName = "_pr-a";
export var refundAmount = "_pr-b";